<template>
  <div class="page-template">
    <div class="page-title">{{ title }}</div>
      <search-form-template
        ref="storeTemplate"
        :searchOptions="searchOptions"
        @searchSubmit="searchSubmit"
        @clear="clearSearch"
        :toolConfig="toolConfig"
        @btnCommon="btnCommon"
      ></search-form-template>
      <div class="centerBack">
        <div class="echartsArea">
          <echarts-template
            class="charts-box"
            ref="reportConsumptionSummary"
            :picOption="reportConsumptionSummary"
          >
          </echarts-template>
        </div>
        <list-template ref="store" :tableOptions="storeReportTable" :tableData="totalList">
          </list-template>

      </div>
  </div>
</template>

<script>
import api from "@/config/api";
import searchFormTemplate from "@/components/template/searchFormTemplate";
import listTemplate from "@/components/template/listTemplate";
import echartsTemplate from "@/components/controls/echarts";
import {reportConsumptionSummary} from "@/page/home/options/reportEcharts";
import userPower from "@/mixin/userPower";

export default {
   mixins: [userPower],
  components: {searchFormTemplate, echartsTemplate,listTemplate},
   created() {
    this.setStore(this.searchOptions.simple);
    this.getData(this.param);
    this.getList(this.param)
  },
  data() {
    let stCreateDttm = this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss');
    let edCreateDttm = this.$moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
    let defaultParam = {storeType: 10, stCreateDttm: stCreateDttm, edCreateDttm: edCreateDttm};
    return {
      totalList:[],
      param: defaultParam,
      reportConsumptionSummary,
      title: "",
      //按门店
      searchOptions: {
        simple: [
          {label: '门店名称', prop: 'storeIds', type: 'select',  multiple: true, data: [],url:api.system.seStore},
        ],
        complex: [
          {label: '会员类别', prop: 'memberCategoryId', type: 'select', url: api.member.category, data: [],span: 12,},
          {
            label: '门店类型',
            prop: 'storeType',
            type: 'radio',
            span: 12,
            defaultValue: 10,
            data: [{label: '开卡门店', value: 10}, {label: '消费门店', value: 20},],
          },
          {
            label: '选择日期',
            prop: 'CreateDttm',
            type: 'dateTimeRangeButton',
            dateType: 'datetime',
            span: 24
          },
        ]
      },
      storeReportTable: {
        indexShow: true, //是否显示索引
        param: defaultParam,
        columns: [
          {
            label: "门店名称",
            prop: "storeName",
            width: "290",
            align: "center",
          },
          {
            label: "单数",
            prop: "orderNum",
            width: "220",
            align: "center",
          },
          {
            label: "消费总额",
            prop: "amountReceived",
            width: "220",
            align: "center",
          },
          {
            label: "本金消费金额",
            prop: "balance",
            width: "240",
            align: "center",
          },
          {
            label: "赠送消费金额",
            prop: "memberGivingMoney",
            width: "240",
            align: "center",
          },
        ],
      },
      toolConfig: [
        {
          label: "导出",
          code: "export",
          callback:this.exportData
        },
      ],
    };
  },

  mounted() {
    this.title = document.title;
  },
  methods: {
    getData(param) {
      this.$axios.fetchPost(api.report.meSummaryEcharts, param).then(data => {
         console.log(data.data)
        if (data.code == 200) {
          this.reportConsumptionSummary.charsOption.xAxis[0].data = data.data.dateTime;
          this.reportConsumptionSummary.charsOption.series[0].data = data.data.amountReceived;
          this.reportConsumptionSummary.charsOption.series[1].data = data.data.orderNum;
          this.$nextTick(() => {
            this.$refs.reportConsumptionSummary.drawpic();
          });
        }
      }).catch(err => {
        this.$message({message: '请求失败！', type: 'error'})
      })
    },
    getList(param){
       this.$axios.fetchPost(api.report.meSummaryList,param).then(data=>{
         this.totalList=data.data
       })
    },
    searchSubmit() {
      const simpleParams = this.$refs.storeTemplate.getSimpleParams();
      console.log(simpleParams)
      const complexParams = this.$refs.storeTemplate.getComplexParams();
      const params = Object.assign({}, this.param, complexParams);
      let $$params = Object.assign({}, params, simpleParams);
      // this.$refs["store"].searchSubmit($$params);
      this.getData($$params);
      this.getList($$params)
    },
    clearSearch() {
      this.getData(this.param)
      this.getList(this.param)
      // this.$refs['store'].clearSearch();
    },
    btnCommon(btnObj) {
      btnObj.callback && btnObj.callback();
    },
    exportData() {
      const simpleParams = Object.assign({}, this.$refs.storeTemplate.getSimpleParams(), this.$refs.storeTemplate.getComplexParams());
      let $param = Object.assign({}, this.param, simpleParams, {exportCode: 'memberConsumeSummaryExport'},)
      this.$axios.fetchPost(api.report.meSummaryExport, $param).then(data => {
        if (data.code === 200) {
          const elink = document.createElement('a');
          elink.href = data.data;
          elink.click();
          this.loadingExt = false;
          this.$notify({
            type: "success",
            title: '导出操作',
            message: '成功',
            showClose: false,
          });
          // this.$message({message: '导出成功', type: 'success'});
        } else {
          this.$notify({
            type: "error",
            title: '导出操作',
            message: '失败',
            showClose: false,
          });
          // this.$message({message: '导出异常', type: 'error'});
        }
      })
    }
  },
};
</script>

<style scoped>
.page-template .centerBack {
  width: 100%;
  /* height: calc(100vh - 62px); */
  background: #fff;
  border-radius: 8px;
  padding: 25px;
  margin-bottom: 10px;
}

.page-template .echartsArea {
  width: 100%;
  height: 500px;
  margin-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// src/page/report/member/consumption/Summary.vue